import '@/assets/css/global.css'
import '@/assets/css/ui.css'
import '@/assets/css/sprite.css'

// import '@/assets/css/sass/common.scss'

import Vue from 'vue'
import App from './App.vue'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import router from './router-config.js'

let mainApp = null;

import '@/directives/index'

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
    ops: {
        rail: {
            opacity: 0.9,
            background: '#e8dbbf',
            size: '6px',
            gutterOfSide: '0px',
        },
        bar: {
            background: '#c33d34',
            keepShow: true,
            size: '6px',
        }
    }, // 在这里设置全局默认配置
    name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll 
});

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入样式
//import 'swiper/css/swiper.css'

//引入样式
// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css'

Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */ )

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

// import {$get,$post} from "@/assets/js/axios.http.js"
// Vue.prototype.$get = $get
// Vue.prototype.$post = $post
import {
    apiUserInfo,
    apiTaskInfo,
    apiTeamInfo
} from '@/api/index';

import {
  token_type
} from '@/api/config';

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL
Vue.prototype.$queryArea = GLOBAL.queryArea;

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//store
import store from "@/components/store/index.js";
Vue.prototype.$store = store;

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

//FREE
import Free_login from '@/assets/js/freeLogin.js';

//login
import esPassport from "@/assets/js/espassport.esm.min";
Vue.prototype.$mslogin = esPassport;
esPassport.init({
  loginUrl: GLOBAL.ajax_url_map.login, // 登录服务端接口地址（必填）
  redirectUrl: GLOBAL.domain // 登录成功后的回调地址（必填）
});

//user_info
import User_info from '@/components/userinfo.vue';
Vue.component('user-info', User_info);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem);

//utils
import utils from '@/components/utils/index.js';
Object.keys(utils).forEach(key => {
    Vue.prototype[key] = utils[key]
})

Vue.prototype.$update_evt = function (data) {
    mainApp.user_init();
};

Vue.prototype.$update_user = function (data) {
    mainApp.user_init();
};

Vue.prototype.$task_render = function (data) {
    mainApp.task_init();
};

Vue.prototype.$team_render = function (data) {
    mainApp.team_info();
};

mainApp = new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App ref="app" :ready="ready"/>',
    data() {
        return {
            ua: {},
            evt_info: {},
            code: '',
            name: null,
            login: 0, //登陆
            aid: 0, //大区id
            account_type: 'pc',
            isLoading: false,
            ready: false, //通信阀门
            share_id: 'ME21',
            key: '',
            share: '',
            token: '',
        }
    },
    created() {
        var _this = this;

        let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem(token_type);
        _this.token = token;

        let code = GLOBAL.getQueryVariable('code') || localStorage.getItem("code");

        this.share = GLOBAL.getQueryVariable('share') || localStorage.getItem("share");
        if (GLOBAL.getQueryVariable('share')) {
            localStorage.setItem('share', this.share);
        }

        if (GLOBAL.getQueryVariable('code')) {
            this.$store.commit("$_setCode", GLOBAL.getQueryVariable('code'));
            localStorage.setItem('code', code);
        }

        this.key = code;

        if (token) {
            localStorage.setItem(token_type, token);
            _this.$store.commit("$_setToken", token);
        }

        window.history.pushState({}, 0, GLOBAL.domain);
    },
    mounted() {
        this.get_user_info();
        let url = GLOBAL.domain.indexOf('http') < 0 ? 'https:' + GLOBAL.domain : GLOBAL.domain;
        wx.wxInit({
            title: GLOBAL.wx_share_text.title, // 分享标题
            desc: GLOBAL.wx_share_text.desc, // 分享描述
            link: url, // 分享链接
            imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        });

        //
    },
    methods: {
        get_user_info() {
            // 调用免登录接口，进行免登录验证
            //TODO 梦平台免登录
            let _this = this;

            this.ua.uid = this.ua.uid || 0;

            Free_login.free_login_lazy(
                this.$store.state.userinfo.accountid, {
                    mplat: ajax_url_map.mplat,
                    kd: ajax_url_map.free,
                },
                function (response) {
                    if (typeof response !== 'undefined') {
                        _this.token = response.data ? response.data : response;
                        localStorage.setItem(token_type, _this.token);
                        _this.$store.commit("$_setToken", _this.token);
                    }
                    _this.user_init();

                }
            );
        },
        user_init() {

            apiUserInfo().then(
                res => {
                    this.$store.commit("$_setUserinfo", res.data);
                    this.$store.commit("$_setLogin", 1);

                    this.task_init();
                    this.team_info();
                    

                    if (localStorage.getItem("code")) return this.$invite_apply({
                        code: this.key
                    });
                },
                rej => {
                    //this.ready = true;
                    this.task_init();

                    console.log(rej)

                    if (rej.code != 401 && rej.code != 402) this.$toast(rej.message);

                    if (rej.data) {

                        this.$store.commit("$_setUserinfo", rej.data);
                        this.$store.commit("$_setAid", 0);
                        this.$store.commit("$_setLogin", 1);
                    }

                    if (localStorage.getItem("code")) return this.$invite_apply({
                        code: this.key
                    });

                    if (rej.code == 402 && !localStorage.getItem("code")) {
                        this.$bind_modal();
                    }
                },
            );

        },
        task_init() {
            apiTaskInfo().then(
                res => {
                    this.ready = true;
                    this.$store.commit("$_setTask", res.data);
                },
                rej => {
                    rej.data && this.$store.commit("$_setTask", rej.data);
                },
            );
        },
        team_info() {
            apiTeamInfo().then(
                res => {
                    this.$store.commit("$_setTeam", res.data);
                    this.$store.commit("$_setMap", res.data.match);
                },
                rej => {
                    rej.data && this.$store.commit("$_setTeam", rej.data.list);
                },
            )
        },
    },
})